import {AbstractFormConfig} from "./abstract-form.config";

export class FormFieldConfig extends AbstractFormConfig {

  constructor(init?: Partial<FormFieldConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
